import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../helpers/history';

// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts';
import 'echarts-gl';

// 引入柱状图
import "echarts/lib/chart/bar";

// 引入提示框和标题组件
import "echarts/lib/component/tooltip";
import 'echarts/lib/component/title';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/scatter';//effectScatter
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/axisPointer';
import 'echarts/lib/component/markArea';
import 'echarts/lib/component/legendScroll';

import { Layout, Table, Modal, Divider, Button, Row, Col, message } from 'antd';
import { getChartOption } from './chartOptions/index';

import emitter from '../Evt.js';

import moment from 'moment';
var moment_timezone = require('moment-timezone');

const { Content } = Layout;

var languageMessages = window.appLocale.messages;

var incomes = {
    'sName': languageMessages['incomeCurve'],
    'xName': languageMessages['date'],
    'xData': [],
    'yName': languageMessages['totalRet'] + '(%)',
    'data': [
        {
            'name': languageMessages['strategyGains'],
            'color': '#ee6666',
            'data': []//[0.00, - 0.18, -0.55, 0.19, -0.96, 0.29, 0.26]
        },
        {
            'name': languageMessages['individualStockIncome'],
            'color': '#5470c6',
            'data': []//[0.73, 1.06, 1.76, 3.19, 1.98, 3.67, 3.26]
        },
        {
            'name': languageMessages['individualStocks+strategyStackingIncome'],
            'color': '#990000',
            'data': []//[0.73, 1.06, 1.76, 3.19, 1.98, 3.67, 3.26]
        }
    ],
};

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

var colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

class BacktestGridResult extends Component {
    constructor(props) {
        super(props);

        window.webType === 'US' ? moment_timezone.tz.setDefault("America/New_York") : moment_timezone.tz.setDefault("Asia/Shanghai");

        this.charts = {
            "income": null
        }
        
        this.state = {
            spinLoadding: false,

            statisticsResult: [],

            dataSource: [],
            infoDataSource: [],

            modalTitle: '',
            modalBacktestId: '',
            modalSymbolCode: '',
            modalSymbolName: '',
            modalStrategyName: '',
            modalStrategyType: '',
            modalVisible: false,

            tradeType: 0,

        }
    }
    
    componentDidMount() {
        const { statisticsResult } = this.props;
        
        this.setBacktestResult(statisticsResult);

        emitter.addListener("callSendTradeError", this.callSendTradeError);
        emitter.addListener("callDeployStrategy", this.callDeployStrategy);
    }

    componentWillUnmount() {
        emitter.removeListener('callSendTradeError', this.callSendTradeError);
        emitter.removeListener('callDeployStrategy', this.callDeployStrategy);
    }

    callSendTradeError = (status) => {
        message.error(languageMessages['deployStrategySubmitFail'] + ', Error:' + status);

        this.setState({ spinLoadding: false, modalVisible: false });
    }

    callDeployStrategy = (status, deployStrategy) => {
        this.setState({ spinLoadding: false, modalVisible: false }, () => {
            if (status == 0) {
                if (deployStrategy.TradeType == 0) {
                    history.push("/re");
                } else {
                    history.push("/si");
                }
            } else {
                message.error(languageMessages['deployStrategyFail'] + ', Error:' + status);
            }
        });
    }

    resizeChart() {
        var incomeChart = this.charts['income'];
        
        window.onresize = function () {
            if (incomeChart != null) incomeChart.resize();
        }
    }

    setIncomeData(chartName, chartData) {
        this.charts[chartName] = echarts.init(document.getElementById(chartName));
        this.charts[chartName].setOption(getChartOption(chartName, chartData));

        this.charts[chartName].resize();

        this.resizeChart();
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            //value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            value = Number(value).toFixed(2);
            value += sign;
        }

        return value;
    }

    setBacktestResult(statisticsResult) {
        this.charts = {
            "income": null
        };

        incomes.xData = [];
        incomes.data[0].data = [];
        incomes.data[1].data = [];
        incomes.data[2].data = [];

        let modalBacktestId = '';
        let modalSymbolCode = '';
        let modalSymbolName = '';
        let modalStrategyType = '';
        let modalStrategyName = '';

        var infoDataSource = [];
        var dataSource = [];

        
        if (statisticsResult.length > 0) {
            let maxProfitFactor = 0;
            let profitFactorItem = [];

            var conditions = [];
            for (var item in statisticsResult) {
                //var strategyName = strReplace(languageMessages['gridStrategy'], { '{num}': statisticsResult[item].gridCnt });

                if (modalBacktestId === '') modalBacktestId = statisticsResult[item].backtestId;
                if (modalSymbolCode === '') modalSymbolCode = statisticsResult[item].symbolCode;
                if (modalSymbolName === '') modalSymbolName = statisticsResult[item].symbolName;
                if (modalStrategyType === '') modalStrategyType = statisticsResult[item].dayTradeOnly;
                

                var strategyName = statisticsResult[item].strategyName;
                strategyName = strategyName.replace('strategy', languageMessages['gridStrategy']);

                conditions.push({ 'id': statisticsResult[item].backtestId, 'name': strategyName });

                var initialRateOfReturnOnCapital = this.keepDecimals(statisticsResult[item].initialRateOfReturnOnCapital, '');
                var annualizedRateOfReturn = this.keepDecimals(statisticsResult[item].annualizedRateOfReturn, '');
                var profitFactor = this.keepDecimals(statisticsResult[item].profitFactor, '');

                infoDataSource.push({
                    key: item,
                    strategyName: strategyName,

                    priceRange: statisticsResult[item].priceRange,
                    gridCnt: statisticsResult[item].gridCnt,
                    gridWidth: statisticsResult[item].gridWidth,
                    capital: statisticsResult[item].capital,

                    initialRateOfReturnOnCapital: initialRateOfReturnOnCapital,
                    annualizedRateOfReturn: annualizedRateOfReturn,
                    profitFactor: profitFactor
                });
            }

            if (conditions.length > 0) {

                modalStrategyName = conditions[0].name;

                //var strategyName = strReplace(languageMessages['gridStrategy'], { '{num}': statisticsResult[item].gridCnt });
                //strategyName = statisticsResult[0].strategyName;

                var rateOfReturn = statisticsResult[0].equityCurve.rateOfReturn;
                var bRateOfReturn = statisticsResult[0].equityCurve.bRateOfReturn;

                incomes.xData = statisticsResult[0].equityCurve.date;
                //incomes.data[0].name = '策略收益';//window.webType === 'US' ? languageMessages['SP500'] : languageMessages['CSI300'];
                incomes.data[0].data = rateOfReturn;
                //incomes.data[1].name = '个股收益';//strategyName;
                incomes.data[1].data = bRateOfReturn;

                var superimposedIncome = [];
                for (var ii in rateOfReturn) {
                    var tmp = parseFloat(rateOfReturn[ii]) + parseFloat(bRateOfReturn[ii]);
                    superimposedIncome.push(this.keepDecimals(tmp.toString(), ''));
                }

                incomes.data[2].data = superimposedIncome;
                /**
                incomes.data.push({
                    'name': statisticsResult[0].strategyName,
                    'color': colors[0],
                    'data': statisticsResult[0].equityCurve.rateOfReturn
                });
                */

                if (statisticsResult[0].trades.length > 0) {
                    var trades = statisticsResult[0].trades;

                    /**
                     * 若 原方向=做空， 则
                       第一行， 方向= 卖出，价格=原“进仓价格”，成交量=abs(原“数量”）成交额=价格*成交量
                        第二行， 方向= 买入，价格=原“出仓价格”，成交量=abs(原“数量”）成交额=价格*成交量
                        若 原方向=做多， 则
                        将 第一行和第二行的方向互换

                        若 原方向=做空， 则
                        第一行， 方向= 卖出，成交价=原“进仓价格”，成交量=abs(原“数量”）成交额=价格*成交量，成交时间=原“进仓时间”
                        第二行， 方向= 买入，成交价=原“出仓价格”，成交量=abs(原“数量”）成交额=价格*成交量，成交时间=原“出仓时间”
                        若 原方向=做多， 则
                        将 第一行和第二行的方向互换
                     * 
                     */

                    var sequence = 1;
                    var index = 1;
                    for (var item in trades) {

                        var pnl = parseFloat(trades[item].pnl);
                        var pnlPercent = parseFloat(trades[item].pnlPercent);

                        var direction = '';
                        var tradeTime = trades[item].entryDatetime;
                        var strikePrice = '';
                        var volume = Math.abs(trades[item].quantity);
                        var turnover = 0;
                        if (trades[item].direction == 'L') {
                            direction = 'L';
                        } else {
                            direction = 'S';
                        }

                        tradeTime = trades[item].entryDatetime;
                        strikePrice = trades[item].entryPrice;
                        var tmpStrikePrice = parseFloat(strikePrice);
                        turnover = volume * tmpStrikePrice;

                        dataSource.push({
                            key: index,//trades[item].backtestId,
                            sequence: sequence,
                            symbolName: trades[item].symbol,
                            tradeTime: tradeTime,
                            strikePrice: strikePrice,
                            direction: direction,
                            volume: volume,
                            turnover: turnover.toFixed(2),
                            pnl: '',
                            pnlp: ''
                        });

                        index++;

                        if (trades[item].direction == 'L') {
                            direction = 'S';
                        } else {
                            direction = 'L';
                        }

                        tradeTime = trades[item].exitDatetime;
                        strikePrice = trades[item].exitPrice;
                        var tmpStrikePrice = parseFloat(strikePrice);
                        turnover = volume * tmpStrikePrice;

                        dataSource.push({
                            key: index,//trades[item].backtestId,
                            sequence: '',
                            symbolName: '',
                            tradeTime: tradeTime,
                            strikePrice: strikePrice,
                            direction: direction,
                            volume: volume,
                            turnover: turnover.toFixed(2),
                            pnl: pnl.toFixed(2),
                            pnlp: pnlPercent.toFixed(2)
                        });

                        sequence++;
                        index++;
                    }
                }
            }
        }
        
        this.setIncomeData("income", incomes);

        this.setState({ dataSource, infoDataSource, statisticsResult, modalBacktestId, modalStrategyName, modalSymbolCode, modalSymbolName, modalStrategyType });
    }

    componentWillReceiveProps(props) {
        const { statisticsResult } = props;

        if (this.state.statisticsResult == statisticsResult) return;
        
        this.setBacktestResult(statisticsResult);
    }

    onRealTime = () => {
        this.setState({
            modalTitle: languageMessages['newRealTimeTrade'],
            modalVisible: true,
            tradeType: 0,
        });
    }

    onSimulation = () => {
        this.setState({
            modalTitle: languageMessages['newSimulationTrade'],
            modalVisible: true,
            tradeType: 1,
        });
    }

    renderModalContent() {
        let fromDate = moment().format('YYYY-MM-DD HH:mm:ss');
        let endDate = moment().add(1, 'months').format('YYYY-MM-DD 15:00:00');
        return <div>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['symbolCode']}：</Col>
                <Col span={16}>
                    <div className="common-gutter-row">{this.state.modalSymbolCode + ' ' + this.state.modalSymbolName}</div>
                </Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['tradingStraregy']}：</Col>
                <Col className="common-gutter-row" span={16}>{this.state.modalStrategyName}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['strategyType']}：</Col>
                <Col className="common-gutter-row" span={16}>{this.state.modalStrategyType === '0' ? languageMessages['crossDay'] : languageMessages['intraday']}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['startTime']}：</Col>
                <Col className="common-gutter-row" span={16}>{fromDate}</Col>
            </Row>
            <Row>
                <Col className="common-gutter-row" span={6}>{languageMessages['endTime']}：</Col>
                <Col className="common-gutter-row" span={16}>{endDate}</Col>
            </Row>
        </div>
    }

    handleOk = e => {
        this.setState({ spinLoadding: true }, () => {
            var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
            if (user.username === undefined) {
                this.setState({ spinLoadding: false }, () => {
                    this.props.dispatch({ type: "action_non_user" });
                });
            } else {
                let { tradeType, modalBacktestId, modalSymbolCode, modalStrategyType } = this.state;

                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'SendTrade',
                        userId: user.username,
                        msg: {
                            Type: 'deployStrategy',
                            TradeType: tradeType,
                            BacktestId: modalBacktestId,
                            StrategyId: 0,
                            SymbolCode: modalSymbolCode,
                            Capital: 10000,
                            DayTradeOnly: modalStrategyType,
                            ReqId: guid()
                        }
                    }
                });
            }
        });
    }

    handleCancel = e => {
        this.setState({ modalVisible: false, spinLoadding: false });
    }

    render() {
        var { dataSource, infoDataSource } = this.state;

        const infoColumns = [
            {
                title: languageMessages['priceRanges'],
                dataIndex: 'priceRange',
                sorter: (a, b) => a.priceRange < b.priceRange ? -1 : a.priceRange > b.priceRange ? 1 : 0,
                sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['gridCnt'],
                dataIndex: 'gridCnt',
                align: 'right',
                sorter: (a, b) => a.gridCnt - b.gridCnt,
                sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['gridWidths'],
                dataIndex: 'gridWidth',
                align: 'right',
                sorter: (a, b) => a.gridWidth - b.gridWidth,
                sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['capitals'],
                dataIndex: 'capital',
                align: 'right',
                sorter: (a, b) => a.capital - b.capital,
                sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['initialRateOfReturnOnCapital']+'(%)',
                dataIndex: 'initialRateOfReturnOnCapital',
                align: 'right',
                sorter: (a, b) => a.initialRateOfReturnOnCapital < b.initialRateOfReturnOnCapital ? -1 : a.initialRateOfReturnOnCapital > b.initialRateOfReturnOnCapital ? 1 : 0,
                sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['initialRateOfReturnOnCapital'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }, {
                title: languageMessages['annualizedRateOfReturn']+'(%)',
                dataIndex: 'annualizedRateOfReturn',
                align: 'right',
                sorter: (a, b) => a.annualizedRateOfReturn < b.annualizedRateOfReturn ? -1 : a.annualizedRateOfReturn > b.annualizedRateOfReturn ? 1 : 0,
                sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['annualizedRateOfReturn'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }, {
                title: languageMessages['profitFactor'],
                dataIndex: 'profitFactor',
                align: 'right',
                sorter: (a, b) => a.profitFactor - b.profitFactor,
                sortDirections: ['descend', 'ascend'],
                render: (text, record) => (
                    <span>
                        {record.profitFactor >= 100000 ? languageMessages['noLoss'] : record.profitFactor == 0 ? languageMessages['noProfit'] : record.profitFactor}
                    </span>
                )
            }
        ];

        const columns = [
            {
                title: languageMessages['sequence'],
                dataIndex: 'sequence',
                align: 'right',
                width: 50
            }, {
                title: languageMessages['symbolCode'],
                dataIndex: 'symbolName',
                //sorter: (a, b) => a.symbolName < b.symbolName ? -1 : a.symbolName > b.symbolName ? 1 : 0,
                //sortDirections: ['descend', 'ascend'],
                //render: (text, record) => <a onClick={() => this.selectRow(record)}>{text}</a>,
            }, {
                title: languageMessages['direction'],
                dataIndex: 'direction',
                //sorter: (a, b) => a.direction < b.direction ? -1 : a.direction > b.direction ? 1 : 0,
                //sortDirections: ['descend', 'ascend'],
                render: (text, record) => (
                    <span>
                        {languageMessages.hasOwnProperty(record.direction) ? languageMessages[record.direction] : record.direction}
                    </span>
                )
            }, {
                title: languageMessages['tradeTimes'],
                dataIndex: 'tradeTime',
                //sorter: (a, b) => a.tradeTimes - b.tradeTimes,
                //sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['strikePrice'],
                dataIndex: 'strikePrice',
                align: 'right',
                //sorter: (a, b) => a.strikePrice - b.strikePrice,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['tradeSize'],
                dataIndex: 'volume',
                align: 'right',
                //sorter: (a, b) => a.volume - b.volume,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['dollars'],
                dataIndex: 'turnover',
                align: 'right',
                //sorter: (a, b) => a.turnover - b.turnover,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['pnls'],
                dataIndex: 'pnl',
                align: 'right',
                //sorter: (a, b) => a.pnl - b.pnl,
                //sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['pnl'] !== '' && row['pnl'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }, {
                title: languageMessages['gain'] + '(%)',
                dataIndex: 'pnlp',
                align: 'right',
                //sorter: (a, b) => a.pnlp - b.pnlp,
                //sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['pnlp'] !== '' && row['pnlp'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }
        ];

        return (<Content>
            <div className='common-title'><Divider type="vertical" />{languageMessages['backtestDetails']}</div>

            <Table bordered size='small' locale={{ emptyText: ' ' }} columns={infoColumns} dataSource={infoDataSource} pagination={false} />

            <div className='common-title'><Divider type="vertical" />{languageMessages['fundsCurve']}</div>
            <div id="income" style={{ height: "500px", marginTop: "20px" }} > </div>

            <div className='common-title'><Divider type="vertical" />{languageMessages['tradeDetails']}</div>

            <Table bordered size='small' locale={{ emptyText: ' ' }} columns={columns} dataSource={dataSource} pagination={dataSource.length >= 60 ? { pageSize: 60 } : false} />
            <Modal
                title={this.state.modalTitle}
                visible={this.state.modalVisible}
                maskClosable={false}
                onOk={this.handleOk}
                confirmLoading={this.state.spinLoadding}
                onCancel={this.handleCancel}>
                {this.renderModalContent()}
            </Modal>
        </Content>);
    }
}

export { BacktestGridResult as default }

/**
function mapStateToProps(state) {
    return state.backtest;
}

const page = connect(mapStateToProps)(BacktestResult);
export { page as default }
 */